import { render, staticRenderFns } from "./SupplierProfileHeader.vue?vue&type=template&id=1d6cfc98"
import script from "./SupplierProfileHeader.vue?vue&type=script&lang=js"
export * from "./SupplierProfileHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports